import { cargarElementoVueCifra } from '../apps/cifra';
/**
 * Se trata de un web component que lo que hace es cargar un componente ya registrado
 */
class CifraVue extends HTMLElement {
  // The browser calls this method when the element is
  // added to the DOM.
  connectedCallback() {
    this.vueApp = cargarElementoVueCifra(this);
  }

  disconnectedCallback() {
    this.vueApp.unmount();
  }
}

customElements.define('cifra-vue', CifraVue);
